export default __webpack_public_path__ + "static/media/logo-white.68e028d4.png";